import React, { createContext, useState, useContext, useEffect } from "react";

const AppContext = createContext();

export function AppProvider({ children }) {
  // ✅ listen for updates from anywhere

  const [updateOrderHistoryNav, setUpdateOrderHistoryNav] = useState(false);

  const [isLogin, setIsLogin] = useState(false);
  const [hasNewBagCount, setHasBagCount] = useState(false);
  const [customerId, setCustomerId] = useState(null);
  const [customerEmail, setCustomerEmail] = useState(null);
  const [customerProvider, setCustomerProvider] = useState(null);
  const [customerfullname, setCustomerfullname] = useState(null);
  const [hasWishlistCount, setHasWishlistCount] = useState(false);
  const [profileChecker, setProfileChecker] = useState(false);

  const [isOrderListUpdate, setOrderListUpdate] = useState(false);
  const [unpaidOrderList, setUnpaidOrderList] = useState([]);
  const [pendingApprovalOrderList, setPendingApprovalOrderList] = useState([]);
  const [partiallyPaidOrderList, setPartiallyPaidOrderList] = useState([]);
  const [declinedOrderList, setDeclinedOrderList] = useState([]);
  const [paidOrderList, setPaidOrderList] = useState([]);
  const [toReceivedOrderList, setToReceivedPaidOrderList] = useState([]);
  const [cancelledOrderList, setCancelledPaidOrderList] = useState([]);
  const [refundedOrderList, setrefundedOrderList] = useState([]);
  const [completedOrderList, setCompletedOrderList] = useState([]);
  const [addressId, setAddressId] = useState(null);
  const [hasNewAddress, setHasNewAddress] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        console.log(
          `${process.env.REACT_APP_BASE_URL}api/auth/customer-profile`
        );
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/auth/customer-profile`,
          {
            credentials: "include",
          }
        );
        const data = await res.json();
        console.log("data: ", data);
        setCustomerId(data.CP_ID);
        setCustomerfullname(`${data.CP_Firstname} ${data.CP_Lastname}`);
        setCustomerEmail(data.CP_Emailaddress);
        setCustomerProvider(data.CP_Provider);
      } catch (e) {
        console.log("SOMETHING WENT WRONG: ", e);
      }
    };

    fetchProfile();
  }, [profileChecker, isLogin]);
  useEffect(() => {
    const getAddressId = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/orders/get-default-address/${customerId}`
        );
        if (!res.ok) {
          throw new Error("Failed to fetch address");
        }

        const data = await res.json();
        //console.log("Address data:", data);

        // Example: if backend returns array of addresses
        const fetchedAddressId = data.addressRow?.[0]?.CA_ID || null;

        //console.log("fetchedAddressId:", fetchedAddressId);

        setAddressId(fetchedAddressId);
      } catch (err) {
        console.error("Error fetching address:", err);
      }
    };

    if (customerId) {
      getAddressId();
    }
  }, [customerId, hasNewAddress]); // runs again if customerId changes
  useEffect(() => {
    //let intervalId;

    async function fetchUnpaidContent() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/orders/get-unpaid-order-by-id/${customerId}`,
          { credentials: "include" }
        );
        if (!res.ok) {
          console.error("HTTP error:", res.status);
          return;
        }
        const data = await res.json();
        if (Array.isArray(data.unpaidOrderList)) {
          setUnpaidOrderList(data.unpaidOrderList);

          // //console.log("data.unpaidOrderList :", data.unpaidOrderList);
          setOrderListUpdate(false);
        } else {
          console.error("Invalid response:", data);
          setUnpaidOrderList([]);
        }
      } catch (err) {
        console.error("Failed to fetch bag contents", err);
        setUnpaidOrderList([]);
      }
    }

    async function fetchPendingApprovalContent() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/orders/get-pending-approval-order-by-id/${customerId}`,
          { credentials: "include" }
        );
        if (!res.ok) {
          console.error("HTTP error:", res.status);
          return;
        }
        const data = await res.json();
        if (Array.isArray(data.transactions)) {
          setPendingApprovalOrderList(data.transactions);
          ////console.log("data.transactions :", data.transactions);
          setOrderListUpdate(false);
        } else {
          console.error("Invalid response:", data);
          setPendingApprovalOrderList([]);
        }
      } catch (err) {
        console.error("Failed to fetch bag contents", err);
        setPendingApprovalOrderList([]);
      }
    }

    async function fetchPartiallyPaidContent() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/orders/get-partially-paid-order-by-id/${customerId}`,
          { credentials: "include" }
        );
        if (!res.ok) {
          console.error("HTTP error:", res.status);
          return;
        }
        const data = await res.json();
        if (Array.isArray(data.partiallyPaidOrderList)) {
          setPartiallyPaidOrderList(data.partiallyPaidOrderList);
          ////console.log("data.partiallyPaidOrderList :",data.partiallyPaidOrderList );
          setOrderListUpdate(false);
        } else {
          console.error("Invalid response:", data);
          setPartiallyPaidOrderList([]);
        }
      } catch (err) {
        console.error("Failed to fetch bag contents", err);
        setPartiallyPaidOrderList([]);
      }
    }

    async function fetchDeclinedContent() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/orders/get-declined-order-by-id/${customerId}`,
          { credentials: "include" }
        );
        if (!res.ok) {
          console.error("HTTP error:", res.status);
          return;
        }
        const data = await res.json();
        if (Array.isArray(data.transactions)) {
          setDeclinedOrderList(data.transactions);
          ////console.log("data.transactions :", data.transactions);
          setOrderListUpdate(false);
        } else {
          console.error("Invalid response:", data);
          setDeclinedOrderList([]);
        }
      } catch (err) {
        console.error("Failed to fetch bag contents", err);
        setDeclinedOrderList([]);
      }
    }

    async function fetchPaidContent() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/orders/get-paid-order-by-id/${customerId}`,
          { credentials: "include" }
        );
        if (!res.ok) {
          console.error("HTTP error:", res.status);
          return;
        }
        const data = await res.json();
        if (Array.isArray(data.paidOrderList)) {
          setPaidOrderList(data.paidOrderList);
          ////console.log("data.paidOrderList :", data.paidOrderList);
          setOrderListUpdate(false);
        } else {
          console.error("Invalid response:", data);
          setPaidOrderList([]);
        }
      } catch (err) {
        console.error("Failed to fetch bag contents", err);
        setPaidOrderList([]);
      }
    }
    async function fetchtoReceivedContent() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/orders/get-to-received-order-by-id/${customerId}`,
          { credentials: "include" }
        );
        if (!res.ok) {
          console.error("HTTP error:", res.status);
          return;
        }
        const data = await res.json();
        if (Array.isArray(data.toReceivePaidOrderList)) {
          setToReceivedPaidOrderList(data.toReceivePaidOrderList);
          ////console.log( "data.toReceivePaidOrderList :", data.toReceivePaidOrderList);
          setOrderListUpdate(false);
        } else {
          console.error("Invalid response:", data);
          setToReceivedPaidOrderList([]);
        }
      } catch (err) {
        console.error("Failed to fetch bag contents", err);
        setToReceivedPaidOrderList([]);
      }
    }
    async function fetchCompletedContent() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/orders/get-completed-order-by-id/${customerId}`,
          { credentials: "include" }
        );
        if (!res.ok) {
          console.error("HTTP error:", res.status);
          return;
        }
        const data = await res.json();
        if (Array.isArray(data.completedOrderList)) {
          setCompletedOrderList(data.completedOrderList);
          ////console.log("data.completedOrderList :", data.completedOrderList);
          setOrderListUpdate(false);
        } else {
          console.error("Invalid response:", data);
          setCompletedOrderList([]);
        }
      } catch (err) {
        console.error("Failed to fetch bag contents", err);
        setCompletedOrderList([]);
      }
    }
    async function fetchCancelledContent() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/orders/get-cancelled-order-by-id/${customerId}`,
          { credentials: "include" }
        );
        if (!res.ok) {
          console.error("HTTP error:", res.status);
          return;
        }
        const data = await res.json();
        if (Array.isArray(data.cancelledOrderList)) {
          setCancelledPaidOrderList(data.cancelledOrderList);
          ////console.log("data.cancelledOrderList :", data.cancelledOrderList);
          setOrderListUpdate(false);
        } else {
          console.error("Invalid response:", data);
          setCancelledPaidOrderList([]);
        }
      } catch (err) {
        console.error("Failed to fetch bag contents", err);
        setCancelledPaidOrderList([]);
      }
    }

    async function fetchRefundedContent() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/orders/get-refunded-order-by-id/${customerId}`,
          { credentials: "include" }
        );
        if (!res.ok) {
          console.error("HTTP error:", res.status);
          return;
        }
        const data = await res.json();
        if (Array.isArray(data.refundedOrderList)) {
          setrefundedOrderList(data.refundedOrderList);
          ////console.log("data.cancelledOrderList :", data.cancelledOrderList);
          setOrderListUpdate(false);
        } else {
          console.error("Invalid response:", data);
          setrefundedOrderList([]);
        }
      } catch (err) {
        console.error("Failed to fetch bag contents", err);
        setrefundedOrderList([]);
      }
    }
    async function fetchAllContent() {
      if (!customerId) return;
      await Promise.all([
        fetchUnpaidContent(),
        fetchPendingApprovalContent(),
        fetchPartiallyPaidContent(),
        fetchDeclinedContent(),
        fetchPaidContent(),
        fetchtoReceivedContent(),
        fetchCompletedContent(),
        fetchCancelledContent(),
        fetchRefundedContent(),
      ]);
    }

    if (customerId) {
      fetchAllContent(); // initial load

      // ⏱️ refresh every 10 seconds
      //intervalId = setInterval(fetchAllContent, 10000);
    }

    // // cleanup interval on unmount or when customerId changes
    //return () => {
    // if (intervalId) clearInterval(intervalId);
    //};
  }, [customerId, isOrderListUpdate]);

  const [isCountListUpdateById, setCountListUpdateById] = useState(false);
  const [statusCountListById, setStatusCountListById] = useState({
    unpaidCount: 0,
    forApprovalCount: 0,
    pendingCount: 0,
    partialCount: 0,
    fullCount: 0,
    toReceived: 0,
    completedCount: 0,
    cancelledCount: 0,
    declinedCount: 0,
    refundedCount: 0,
  });

  //Admin

  const [isCountListUpdate, setCountListUpdate] = useState(false);
  const [statusCountList, setStatusCountList] = useState({
    partialCount: 0,
    fullCount: 0,
    forApprovalCount: 0,
    ready2shipCount: 0,
    shippedCount: 0,
    completedCount: 0,
    caccelledCount: 0,
  });

  return (
    <AppContext.Provider
      value={{
        isLogin,
        setIsLogin,
        profileChecker,
        setProfileChecker,
        hasNewBagCount,
        setHasBagCount,
        addressId,
        hasNewAddress,
        setHasNewAddress,
        setAddressId,
        customerId,
        customerEmail,
        customerfullname,
        customerProvider,
        setCustomerProvider,
        setCustomerId,
        unpaidOrderList,
        setUnpaidOrderList,
        pendingApprovalOrderList,
        setPendingApprovalOrderList,
        partiallyPaidOrderList,
        setPartiallyPaidOrderList,
        declinedOrderList,
        setDeclinedOrderList,
        paidOrderList,
        setPaidOrderList,
        toReceivedOrderList,
        setToReceivedPaidOrderList,
        completedOrderList,
        setCompletedOrderList,
        cancelledOrderList,
        setCancelledPaidOrderList,
        refundedOrderList,
        setrefundedOrderList,
        isCountListUpdateById,
        setCountListUpdateById,
        statusCountListById,
        setStatusCountListById,
        isOrderListUpdate,
        setOrderListUpdate,
        statusCountList,
        setStatusCountList,
        isCountListUpdate,
        setCountListUpdate,
        updateOrderHistoryNav,
        setUpdateOrderHistoryNav,
        hasWishlistCount,
        setHasWishlistCount,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  return useContext(AppContext);
}
